import styled from '@emotion/styled';

export const Container  = styled.div`
  width: 240px;
  height: 240px;
`; 